import { useState } from "react";
import axios from "axios";
import styles from "../assets/css/AddPromotion.module.css";
import { BASE_URL } from "../constants/constants";

const AddPromotion = ({ onClose, onUpdate }) => {
  const [formData, setFormData] = useState({
    title: "",
    bannerDescription: "",
    fullDescription: "",
    promocode: "",
    percent: "",
    startDate: "",
    deadline: "",
  });

  const token = localStorage.getItem("token");

  const headers = {
    Authorization: `Bearer ${token}`,
    "Content-Type": "application/json",
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const payload = {
      ...formData,
      percent: Number(formData.percent),
      isActive: true,
      isPublic: true,
      promotionType: "type_1",
    };

    try {
      const response = await axios.post(`${BASE_URL}/v0/promotions`, payload, {
        headers,
      });
      console.log("Успешно добавлено:", response.data);
      alert("Успешно добавлено!")
      onUpdate();
      onClose();
    } catch (error) {
      console.error(
        "Ошибка при добавлении:",
        error.response?.data || error.message
      );
      alert("Ошибка при добавлении")
    }
  };

  return (
    <div className={styles.modal}>
      <form className={styles.container} onSubmit={handleSubmit}>
        <div className={styles.box}>
          <div className={styles.text}>Добавить</div>
          <img
            onClick={onClose}
            className={styles.closeicon}
            src="/images/close.svg"
            alt="close icon"
          />
        </div>
        <input
          className={styles.input}
          name="title"
          value={formData.title}
          onChange={handleChange}
          placeholder="Введите название"
          type="text"
          maxLength="100"
          required
        />
        <input
          className={styles.input}
          name="bannerDescription"
          value={formData.bannerDescription}
          onChange={handleChange}
          placeholder="Введите описание для баннера"
          type="text"
          maxLength="100"
          required
        />
        <textarea
          className={styles.input}
          name="fullDescription"
          value={formData.fullDescription}
          onChange={handleChange}
          placeholder="Введите полное описание"
          maxLength="500"
          required
        />
        <input
          className={styles.input}
          name="promocode"
          value={formData.promocode}
          onChange={handleChange}
          placeholder="Введите название промокода"
          type="text"
          maxLength="150"
          required
        />
        <input
          className={styles.input}
          name="percent"
          value={formData.percent}
          onChange={handleChange}
          placeholder="Введите %"
          type="number"
          required
        />
        <div className={styles.label}>Срок действия промокода</div>
        <div className={styles.dateWrapper}>
          <input
            className={styles.date}
            name="startDate"
            value={formData.startDate}
            onChange={handleChange}
            type="date"
            required
          />
          <input
            className={styles.date}
            name="deadline"
            value={formData.deadline}
            onChange={handleChange}
            type="date"
            required
          />
        </div>
        <div className={styles.box1}>
          <button type="submit" className={styles.addbtn}>
            Добавить
          </button>
          <button type="button" onClick={onClose} className={styles.cancelbtn}>
            Отмена
          </button>
        </div>
      </form>
    </div>
  );
};

export default AddPromotion;
